import React, { useState, useEffect } from 'react';

// EnergyTransfer bileşenine 'results' prop'unu ekleyin:
const EnergyTransfer = ({ id, darkMode, solarEnabled, imagePath = "/icons/capsule.png", results }) => {
  const [rotation, setRotation] = useState(0);
  
  // Dönen animasyon efekti
  useEffect(() => {
    const interval = setInterval(() => {
      setRotation(prev => (prev + 0.5) % 360); // Daha küçük adım
    }, 100); // Daha uzun süre
    return () => clearInterval(interval);
  }, []);
  
  // Kartların renklerine uygun renk şeması
  const colors = {
    left: "#5B9BD5",  // Chiller - açık mavi
    right: "#7030A0", // Boiler - mor
    solar: "#FFC000"  // Güneş - sarı/altın
  };
  
  return (
    <div className="relative w-1/5 mx-1 flex flex-col items-center justify-center">
      <div className="relative h-full w-full mb-6">
        {/* Animasyonlu döngüler - Z-INDEX DÜŞÜRÜLDÜ */}
        <div className="absolute inset-0 flex items-center justify-center z-5">
          {/* Sol enerji döngüsü */}
          <div className="w-2/5 -ml-6 transform scale-110">
            <svg viewBox="0 0 100 100" className="w-full">
              <defs>
                <linearGradient id={`cycleGradientLeft-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor={colors.left} stopOpacity="0.8" />
                  <stop offset="100%" stopColor={colors.left} stopOpacity="0.4" />
                </linearGradient>
                
                {/* Parlama efekti */}
                <filter id={`glowLeft-${id}`} x="-20%" y="-20%" width="140%" height="140%">
                  <feGaussianBlur stdDeviation="2" result="blur" />
                  <feComposite in="SourceGraphic" in2="blur" operator="over" />
                </filter>
              </defs>
              
              {/* Sol döngü yolu */}
              <path 
                d="M 90,50 
                   C 90,30 70,10 50,10 
                   C 30,10 10,30 10,50 
                   C 10,70 30,90 50,90 
                   C 70,90 90,70 90,50 Z" 
                fill="none" 
                stroke={`url(#cycleGradientLeft-${id})`} 
                strokeWidth="4" 
                strokeLinecap="round"
                filter={`url(#glowLeft-${id})`}
              />
              
              {/* Oklar - dönen */}
              <g transform={`rotate(${rotation} 50 50)`}>
                {[45, 135, 225, 315].map((angle, index) => {
                  const radians = angle * Math.PI / 180;
                  const x = 50 + 35 * Math.cos(radians);
                  const y = 50 + 35 * Math.sin(radians);
                  const arrowAngle = angle + 180;
                  
                  return (
                    <g key={index} transform={`translate(${x}, ${y}) rotate(${arrowAngle})`}>
                      <path 
                        d="M-5,0 L0,-8 L5,0 Z" 
                        fill={colors.left} 
                        opacity="0.9"
                      />
                    </g>
                  );
                })}
              </g>
              
              {/* Enerji parçacıkları */}
              <g transform={`rotate(${rotation * 1.5} 50 50)`}>
                {Array(8).fill().map((_, index) => {
                  const angle = (index * 45) * Math.PI / 180;
                  const distance = 25 + (index % 3) * 10;
                  const x = 50 + distance * Math.cos(angle);
                  const y = 50 + distance * Math.sin(angle);
                  
                  return (
                    <circle 
                      key={`left-particle-${index}`} 
                      cx={x} 
                      cy={y} 
                      r={2 + (index % 3)}
                      fill={colors.left}
                      opacity={0.6 + (index % 3) * 0.1}
                    />
                  );
                })}
              </g>
              
              {/* Merkezden dışa enerji tanecikleri */}
              {Array(4).fill().map((_, index) => {
                const angle = ((index * 90) + rotation) % 360;
                const radians = angle * Math.PI / 180;
                const distance = (rotation + index * 30) % 40;
                const x = 50 + distance * Math.cos(radians);
                const y = 50 + distance * Math.sin(radians);
                return (
                  <circle
                    key={`center-to-left-${index}`}
                    cx={x}
                    cy={y}
                    r={1.5 + index % 2}
                    fill={colors.left}
                    opacity={0.7 - distance / 60}
                  />
                );
              })}
            </svg>
          </div>
          
          {/* Orta boş alan */}
          <div className="w-1/5 px-0.5">
            {/* Boşluk */}
          </div>
          
          {/* Sağ enerji döngüsü */}
          <div className="w-2/5 -mr-6 transform scale-110">
            <svg viewBox="0 0 100 100" className="w-full">
              <defs>
                <linearGradient id={`cycleGradientRight-${id}`} x1="100%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor={colors.right} stopOpacity="0.8" />
                  <stop offset="100%" stopColor={colors.right} stopOpacity="0.4" />
                </linearGradient>
                
                {/* Parlama efekti */}
                <filter id={`glowRight-${id}`} x="-20%" y="-20%" width="140%" height="140%">
                  <feGaussianBlur stdDeviation="2" result="blur" />
                  <feComposite in="SourceGraphic" in2="blur" operator="over" />
                </filter>
              </defs>
              
              {/* Sağ döngü yolu */}
              <path 
                d="M 90,50 
                   C 90,30 70,10 50,10 
                   C 30,10 10,30 10,50 
                   C 10,70 30,90 50,90 
                   C 70,90 90,70 90,50 Z" 
                fill="none" 
                stroke={`url(#cycleGradientRight-${id})`} 
                strokeWidth="4" 
                strokeLinecap="round"
                filter={`url(#glowRight-${id})`}
              />
              
              {/* Oklar - ters yönde dönen */}
              <g transform={`rotate(${-rotation} 50 50)`}>
                {[45, 135, 225, 315].map((angle, index) => {
                  const radians = angle * Math.PI / 180;
                  const x = 50 + 35 * Math.cos(radians);
                  const y = 50 + 35 * Math.sin(radians);
                  const arrowAngle = angle;
                  
                  return (
                    <g key={index} transform={`translate(${x}, ${y}) rotate(${arrowAngle})`}>
                      <path 
                        d="M-5,0 L0,-8 L5,0 Z" 
                        fill={colors.right} 
                        opacity="0.9"
                      />
                    </g>
                  );
                })}
              </g>
              
              {/* Enerji parçacıkları - ters yönde */}
              <g transform={`rotate(${-rotation * 1.5} 50 50)`}>
                {Array(8).fill().map((_, index) => {
                  const angle = (index * 45) * Math.PI / 180;
                  const distance = 25 + (index % 3) * 10;
                  const x = 50 + distance * Math.cos(angle);
                  const y = 50 + distance * Math.sin(angle);
                  
                  return (
                    <circle 
                      key={`right-particle-${index}`} 
                      cx={x} 
                      cy={y} 
                      r={2 + (index % 3)}
                      fill={colors.right}
                      opacity={0.6 + (index % 3) * 0.1}
                    />
                  );
                })}
              </g>
              
              {/* Merkezden dışa enerji tanecikleri */}
              {Array(4).fill().map((_, index) => {
                const angle = ((index * 90) - rotation) % 360;
                const radians = angle * Math.PI / 180;
                const distance = (rotation + index * 30) % 40;
                const x = 50 + distance * Math.cos(radians);
                const y = 50 + distance * Math.sin(radians);
                return (
                  <circle
                    key={`center-to-right-${index}`}
                    cx={x}
                    cy={y}
                    r={1.5 + index % 2}
                    fill={colors.right}
                    opacity={0.7 - distance / 60}
                  />
                );
              })}
            </svg>
          </div>
        </div>

        {/* Merkez resim ve güneş - Z-INDEX ARTIRILDI */}
        <div className="absolute inset-0 flex items-center justify-center z-20">
          <div className="w-4/5 h-4/5 relative flex items-center justify-center">
            {/* Isı Pompası Resmi */}
            <div className="relative">
              <img 
                src={imagePath} 
                alt="Isı Pompası" 
                className="w-32 h-32 object-contain relative z-30" 
              />
              
              {/* Güneş animasyonu */}
              {solarEnabled && (
                <div className="absolute top-0 right-0 w-16 h-16 transform -translate-y-12 translate-x-4 z-40">
                  <svg viewBox="0 0 60 60" className="w-full h-full">
                    <defs>
                      <radialGradient id={`sun-gradient-${id}`} cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                        <stop offset="0%" stopColor="#FFEF5A" />
                        <stop offset="90%" stopColor={colors.solar} />
                      </radialGradient>
                      <filter id={`sun-glow-${id}`} x="-50%" y="-50%" width="200%" height="200%">
                        <feGaussianBlur stdDeviation="3" result="blur" />
                        <feComposite in="SourceGraphic" in2="blur" operator="over" />
                      </filter>
                    </defs>
                    
                    {/* Güneş */}
                    <circle 
                      cx="30" 
                      cy="30" 
                      r="15" 
                      fill={`url(#sun-gradient-${id})`}
                      className="animate-pulse-slow" 
                      filter={`url(#sun-glow-${id})`}
                      opacity="0.9"
                    />
                    
                    {/* Güneş ışınları */}
                    {[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map((angle) => (
                      <line 
                        key={`sun-ray-${angle}`}
                        x1="30" 
                        y1="30" 
                        x2={30 + Math.cos(angle * Math.PI / 180) * 12} 
                        y2={30 + Math.sin(angle * Math.PI / 180) * 12}
                        stroke={colors.solar}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        opacity="0.8"
                        className="animate-pulse-slow"
                      />
                    ))}
                  </svg>
                </div>
              )}

              {/* Güneşten düşen enerji parçacıkları */}
              {solarEnabled && (
                <div className="absolute inset-0 z-25">
                  <svg viewBox="0 0 100 100" className="w-full h-full">
                    {/* Güneşten pompaya düşen enerji parçacıkları */}
                    {Array(8).fill().map((_, index) => {
                      const offsetX = Math.sin(rotation/10 + index) * 10; 
                      const startY = 10 - (index * 2);
                      const size = 1 + Math.random() * 2;
                      
                      return (
                        <circle
                          key={`energy-particle-${index}`}
                          cx={75 + offsetX}
                          cy={startY + (rotation + index * 50) % 60}
                          r={size}
                          fill={colors.solar}
                          opacity={0.8 - (index * 0.05)}
                          className="animate-bounce-slow"
                        />
                      );
                    })}
                    
                    {/* Güneşten pompaya enerji akışı çizgileri */}
                    {Array(5).fill().map((_, index) => {
                      const offsetX = 5 + (index * 4); 
                      const offsetY = 5 + (index * 4);
                      const dashLength = 2 + (index % 3);
                      
                      return (
                        <path
                          key={`energy-flow-${index}`}
                          d={`M ${75 + offsetX},${15 + offsetY} L 50,50`}
                          stroke={colors.solar}
                          strokeWidth="1"
                          strokeDasharray={`${dashLength} ${dashLength * 1.5}`}
                          opacity={0.7 - index * 0.1}
                          strokeLinecap="round"
                          className="animate-dash-reverse"
                        />
                      );
                    })}
                  </svg>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      
      {/* "Isı Pompası" yazısı - COP değeri ile */}
      <div className="flex justify-center items-center mt-10">
        <div className={`
          px-8 py-1 rounded-md
          ${darkMode 
            ? 'bg-gradient-to-r from-[#5B9BD5]/30 to-[#7030A0]/30 shadow-inner border border-white/10' 
            : 'bg-gradient-to-r from-[#5B9BD5]/20 to-[#7030A0]/20 shadow-md'}
        `}>
          <div className="flex flex-col items-center">
            <span className={`
              font-semibold text-x
              ${darkMode 
                ? 'text-white drop-shadow-md' 
                : 'text-[#1F4E79] drop-shadow-sm'
              }
            `}>
              Isı Pompası
            </span>
            
            {/* COP değerini koşullu olarak göster */}
            {results && results.cop && (
              <span className={`
                font-bold text-xs mt-1
                ${darkMode 
                  ? 'text-yellow-300' 
                  : 'text-blue-800'
                }
              `}>
                Performans Katsayısı: {results.cop.toFixed(2)}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnergyTransfer;